import type { ICategoryLeadersNavParams, ICategoryLeadersServices } from "../../CategoryLeaders.types";
import type { ICategoryLeadersTableSort } from "app/pages/industry-analysis/category-leaders/components/CategoryLeadersTable/CategoryLeadersTable.types";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { ECategoryLeadersMetricType } from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";

export const getTableApiEndpoints = (metricType: ECategoryLeadersMetricType) => {
    switch (metricType) {
        case ECategoryLeadersMetricType.CategoryLeadersAds:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersAds/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersAds/Excel",
            };
        case ECategoryLeadersMetricType.CategoryLeadersDirect:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersDirect/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersDirect/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersMail:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersMail/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersMail/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersReferrals:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersReferrals/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersReferrals/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersSearch:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersSearch/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersSearch/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersSocial:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersSocial/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersSocial/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersGenAi:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersGenAi/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersGenAi/Excel",
            };

        case ECategoryLeadersMetricType.CategoryLeadersAffiliates:
            return {
                dataEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersAffiliates/Table",
                excelEndpoint: "/widgetApi/CategoryLeaders/CategoryLeadersAffiliates/Excel",
            };

        default:
            return null;
    }
};

export const getTableFilters = (
    navParams: ICategoryLeadersNavParams,
    sort: ICategoryLeadersTableSort,
    services: ICategoryLeadersServices,
    metricType: ECategoryLeadersMetricType,
) => {
    const { category: categoryId } = navParams;

    const isCustomCategory = UserCustomCategoryService.isCustomCategory(categoryId);
    const category = services.categoryService.categoryQueryParamToCategoryObject(categoryId);

    const tableApiParams = {
        ...navParams,
        category: category.forApi,
        keys: category.forApi,
        categoryHash: isCustomCategory ? category.categoryHash : "",
        isWindow: false,
        timeGranularity: "Monthly",
        includeSubDomains: true,
        orderBy: `${sort.field} ${sort.sortDirection}`,
        tab: ECategoryLeadersMetricType[metricType],
        sort: sort.field,
        asc: sort.sortDirection === "asc",
    };

    return services.apiHelper.transformParamsForAPI(tableApiParams);
};

export const getUrlForTableRecord = (
    row: { Domain: string },
    navParams: ICategoryLeadersNavParams,
    services: ICategoryLeadersServices,
) => {
    const { Domain } = row;
    const { country, duration, webSource } = navParams;

    const toState = "digitalsuite_website_websiteperformance";
    const navigationParams = {
        key: Domain,
        country,
        duration,
        webSource,
        isWWW: "*",
    };
    const innerLink = services.navigator.href(toState, navigationParams);
    return innerLink;
};
